import { type Theme } from '#app/theme/index.js';
import {
  type ColOffset,
  type ColSize,
  type ColSizeBreakpointProps,
} from './types.js';
import { css, styled } from 'styled-components';

const COLUMNS = 12;

type StyledColProps = ColSizeBreakpointProps & {
  $gap: number;
  $offset?: ColOffset;
  $size?: ColSize;
};

const gridCalc = (size: ColSize): string => {
  return `${((Number.parseInt(size, 10) / COLUMNS) * 100).toFixed(3)}%`;
};

const getColumnSize = (gap: number, size: ColSize, offset?: ColOffset) => {
  return css`
    max-width: calc(${gridCalc(size)} - ${gap}px);
    flex-basis: calc(${gridCalc(size)} - ${gap}px);

    ${offset ? `margin-left: ${gridCalc(offset)}` : null}
  `;
};

const breakpointCss = (
  mediaQuery: string,
  gap: number,
  size: ColSize,
  offset?: ColOffset,
) => css`
  ${mediaQuery} {
    ${getColumnSize(gap, size, offset)}
  }
`;

const includeBreakpoints = (
  theme: Theme,
  gap: number,
  {
    lg,
    lgOffset,
    md,
    mdOffset,
    sm,
    smOffset,
    xl,
    xlOffset,
  }: ColSizeBreakpointProps,
) => {
  if (sm || md || lg || xl) {
    return css`
      ${sm ? breakpointCss(theme.mediaQueries.sm, gap, sm, smOffset) : null}
      ${md ? breakpointCss(theme.mediaQueries.md, gap, md, mdOffset) : null}
      ${lg ? breakpointCss(theme.mediaQueries.lg, gap, lg, lgOffset) : null}
      ${xl ? breakpointCss(theme.mediaQueries.xl, gap, xl, xlOffset) : null}
    `;
  }

  return null;
};

export const StyledCol = styled.div<StyledColProps>`
  ${({
    $gap,
    $offset,
    $size,
    lg,
    lgOffset,
    md,
    mdOffset,
    sm,
    smOffset,
    theme,
    xl,
    xlOffset,
  }) => css`
    box-sizing: border-box;
    /* max-width: calc(100% - ${$gap}px); */
    flex: 1;
    margin-left: ${$gap / 2}px;
    margin-right: ${$gap / 2}px;

    ${$size ? getColumnSize($gap, $size, $offset) : null}

    ${includeBreakpoints(theme, $gap, {
      lg,
      lgOffset,
      md,
      mdOffset,
      sm,
      smOffset,
      xl,
      xlOffset,
    })}
  `}
`;
